import { useState, useEffect } from 'react'

export const useArtistEditor = (isOpen, artist, onSave, onClose) => {
  const [editedArtist, setEditedArtist] = useState({
    name: '',
    performanceDate: '',
    setTime: '',
    performance: '',
    comment: '',
    seen: false,
    favorite: false
  })

  useEffect(() => {
    if (isOpen && artist) {
      setEditedArtist({
        name: artist.name || '',
        performanceDate: artist.performanceDate || '',
        setTime: artist.setTime || '',
        performance: artist.performance || '',
        comment: artist.comment || '',
        seen: artist.seen || false,
        favorite: artist.favorite || false
      })
    }
  }, [isOpen, artist])

  const handleSave = () => {
    onSave(editedArtist)
    onClose()
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Escape') {
      onClose()
    }
  }

  const updateField = (field, value) => {
    setEditedArtist(prev => ({ ...prev, [field]: value }))
  }

  return {
    editedArtist,
    handleSave,
    handleKeyPress,
    updateField
  }
}